import axios from 'axios';

const courseAPI = {
	sendFinalGrade: async (request:	PostFinalGrade) => {
		const response = await axios.post('/teacher/student/finalgrade', request);
		return response.data as string;
	},
};

export default courseAPI;